import salaryRanks from "./salaryRanks";
import contracts from "./contracts";

export default {
  namespaced: true,
  modules: {
    salaryRanks,
    contracts,
  },
};
